/**
 * @generated SignedSource<<8c5c71604b2b7c342534cc0cda6e842a>>
 * @relayHash d628801de49aa5093fee568fc182828d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c2ffb45b563e23441251e860dbb87504b353d4e8ff2e4b70b88aa208de90a395

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { assigneeEditView_rootQuery } from './assigneeEditView_rootQuery.graphql';

import shouldFetchAppUserType_provider from '@atlassian/jira-relay-provider/src/jira-ai-fetch-apptype-for-user-assignee.relayprovider';

const node: PreloadableConcreteRequest<assigneeEditView_rootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "c2ffb45b563e23441251e860dbb87504b353d4e8ff2e4b70b88aa208de90a395",
    "metadata": {},
    "name": "assigneeEditView_rootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaifetchapptypeforuserassigneerelayprovider": shouldFetchAppUserType_provider
    }
  }
};

export default node;
